

































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { Registration as IRegistration } from "@/api-v2/learning-group/models/registration";
import TableActions from "@/components/form/TableActions.vue";

@Component({ components: { TableActions, CustomTableCol, CustomTableItem } })
export default class LearningGroupStudentTableItem extends Vue {
  @Prop() registration!: IRegistration;
  @Prop({ default: true }) allowToEdit!: boolean;
}
